export default __webpack_public_path__ + "6864118f2fd3901e0e56516110c89417.woff2";